import { render, staticRenderFns } from "./OrderInfoView.vue?vue&type=template&id=5e2e5d95&scoped=true&"
import script from "./OrderInfoView.vue?vue&type=script&lang=js&"
export * from "./OrderInfoView.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoView.vue?vue&type=style&index=0&id=5e2e5d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e5d95",
  null
  
)

export default component.exports